import styles from "./main.module.css";
import { ReactComponent as Logo } from "../../assets/svgs/cipm-logo.svg";
import { useLocation } from "react-router-dom";
import CustomButton from "../../customs/button/button";
import {useNavigate} from "react-router-dom"
import { profileDetails, userAtom } from "../../utils/store";
import { useResetAtom } from "jotai/utils";
import { handleLogOut } from "../helpers";

interface Props {
  children?: React.ReactNode;
  buttonText?: string;
}
const LandingPage: React.FC<Props> = ({ children, buttonText }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const resetUser = useResetAtom(userAtom)
  const resetUserDetails = useResetAtom(profileDetails)
  

 
  
  return (
    <section className={styles.landingPage}>
      <div className={styles.children}>
        <div className={styles.header}>
          <Logo />
          <p className={styles.logoText}>
            Chartered Institute of Personnel  Management of Nigeria
          </p>
        </div>
        {children}
        <div className={styles.buttonDiv}>
          {location.pathname === "/need-help" ? (
            <CustomButton variant="primary" width="19.8rem" onClick={handleLogOut}>Cancel</CustomButton> 
          ) : (
            <CustomButton variant="primary" width="19.8rem" onClick={() => navigate("/need-help")}>Need Help from ICT? </CustomButton>
          )}

          
        </div>
      </div>
    </section>
  );
};

export default LandingPage;
